// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"16":"4eb2f53c","364":"eceb6c2a","819":"28a23783","867":"0f8d0e82","933":"e9a271e5"}[chunkId] + ".chunk.js";
};